import { Component, OnInit, Input, EventEmitter, OnChanges, Output } from '@angular/core';

// Import's externos:
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-header-soma',
  templateUrl: './header-soma.component.html',
  styleUrls: ['./header-soma.component.css']
})
export class HeaderSomaComponent implements OnInit, OnChanges {

  @Input() public listaSedes : ObjetoFiltroSedes[] = [];

  @Output() public objetoReporteSoma : EventEmitter<ObjetoParametrosFiltro>;

  public activeAllCheck : boolean = false;

  public getActiveAllCheck() {
    if(this.activeAllCheck == true) {
      this.activeAllCheck = false;
    } else {
      this.activeAllCheck = true;
    }
  }

  private objetoParametrosFiltros : ObjetoParametrosFiltro = {
    idSede : "",
    fechaInicial : null,
    fechaFinal : null
  }

  public dpConfig : Partial<BsDatepickerConfig> = new BsDatepickerConfig();

  constructor( private localeServiceEs : BsLocaleService ) {
    this.dpConfig.containerClass = "theme-default";
    this.dpConfig.dateInputFormat = "DD/MM/YYYY";
    this.localeServiceEs.use( "es" );

    this.objetoReporteSoma = new EventEmitter();
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getListaSedes();
    this.getObjetoReporteSoma();
  }

  public getObjetoReporteSoma() {
    this.objetoReporteSoma.emit( this.objetoParametrosFiltros );
  }

  public getFechaInicio( fecha : Date ) {
    if( fecha != null ) {
      this.objetoParametrosFiltros.fechaInicial = fecha;
    }
  }

  public getFechaFinal( fecha : Date ) {
    if( fecha != null ) {
      this.objetoParametrosFiltros.fechaFinal = fecha;
    }
  }

  public getSede( descripcionSede : string, event : any ) {
    for (let i = 0; i < this.listaSedes.length; i++) {
      if(  event.target.checked ) {
        if( this.listaSedes[i].descripcion == descripcionSede ) {
          this.objetoParametrosFiltros.idSede += this.listaSedes[i].idSede + ",";
        }
      } else {
        if( this.listaSedes[i].descripcion == descripcionSede ) {
          this.objetoParametrosFiltros.idSede = this.objetoParametrosFiltros.idSede.replace(this.listaSedes[i].idSede +",", "");
        }
      }
    }
  }
  public getAllSede( event : any ) {
    if(  event.target.checked ) {
      for (let i = 0; i < this.listaSedes.length; i++) {
        this.objetoParametrosFiltros.idSede += this.listaSedes[i].idSede + ","
      }
    } else {
      this.objetoParametrosFiltros.idSede = "";
    }
  }

  private async getListaSedes() {
    try {
      await this.listaSedes;
    }catch(exception) {
      console.log(exception);
    }
  }

}

interface ObjetoFiltroSedes {
  idSede : string,
  descripcion : string
}

interface ObjetoParametrosFiltro {
  idSede : string,
  fechaInicial : Date,
  fechaFinal : Date
}
